// rankingRepository.js
// API repository for ranking-related backend calls
import { buildApiUrl, defaultHeaders } from './apiUtils.js';

export const RankingRepository = {
    /**
     * Get aggregated ranking based on tournament type and date
     * @param {Object} params - Query parameters
     * @param {string} params.type - Tournament type ('americano' or 'mexicano')
     * @param {number} params.date - Date as seconds since 1970 (Unix timestamp)
     * @returns {Promise<Object>} Ranking data with player rankings
     */
    async getRanking({ type, date }) {
        const queryParams = new URLSearchParams({
            type: type,
            date: date
        });
        
        const response = await fetch(buildApiUrl(`/ranking?${queryParams}`), {
            method: 'GET',
            headers: defaultHeaders
        });
        
        if (!response.ok) {
            throw new Error(`Failed to fetch ranking: ${response.status} ${response.statusText}`);
        }
        
        return await response.json();
    }
};

export default RankingRepository;
